import type { Companion } from "./data";

export function CompanionAvatar({
  companion,
  small = false,
}: {
  companion: Companion;
  small?: boolean;
}) {
  return (
    <div
      aria-hidden="true"
      className={`companion-avatar ${small ? "companion-avatar--small" : ""}`}
      style={{ "--avatar-accent": companion.accent } as React.CSSProperties}
     data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionAvatar.tsx:11:5"}>
      {companion.avatar}
    </div>
  );
}
